import React, {Component} from 'react';

export default class Society extends Component{
    render(){

        return (
            <div>{this.props.children}</div>
        )
    }
}
